/**
 * @generated SignedSource<<0358e2665e432fefc8c0f02400e65259>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type salesChannelActiveFragmentQuery$variables = Record<PropertyKey, never>;
export type salesChannelActiveFragmentQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"salesChannelsActive">;
};
export type salesChannelActiveFragmentQuery = {
  response: salesChannelActiveFragmentQuery$data;
  variables: salesChannelActiveFragmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskID",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelActiveFragmentQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "salesChannelsActive"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "salesChannelActiveFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserInfo",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "userID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          (v0/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "status",
            "value": "ACTIVE"
          }
        ],
        "concreteType": "SalesChannel",
        "kind": "LinkedField",
        "name": "salesChannels",
        "plural": true,
        "selections": [
          (v0/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesChannelDetail",
            "kind": "LinkedField",
            "name": "detail",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesChannelDetailProperties",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "storePosition",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EcommerceSettings",
            "kind": "LinkedField",
            "name": "ecommerceSettings",
            "plural": false,
            "selections": [
              (v0/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ecommerceGlobalID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ecommerceID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "ecommerceName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "remoteUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isMarketplace",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "definitiveUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "currencyCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": "salesChannels(status:\"ACTIVE\")"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductSwitcherTask",
        "kind": "LinkedField",
        "name": "productSwitcherTasks",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taskType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastError",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "elapsedTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "modifiedOn",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductSwitcherTaskExtraData",
            "kind": "LinkedField",
            "name": "extraData",
            "plural": false,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "masterSalesChannelID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "secondarySalesChannelID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "delayMinutes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentMethodSetupTaskID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceSalesChannelID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "destinationSalesChannelID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isSourceSalesChannelDisabled",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v0/*:: as any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSellerMigrating",
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d78ce8c6b845b0c73041b5f31a944180",
    "id": null,
    "metadata": {},
    "name": "salesChannelActiveFragmentQuery",
    "operationKind": "query",
    "text": "query salesChannelActiveFragmentQuery {\n  ...salesChannelsActive\n}\n\nfragment salesChannelsActive on Query {\n  user {\n    userID\n    email\n    id\n  }\n  salesChannels(status: ACTIVE) {\n    id\n    detail {\n      id\n      properties {\n        name\n        storePosition\n      }\n    }\n    ecommerceSettings {\n      id\n      ecommerceGlobalID\n      ecommerceID\n      ecommerceName\n      remoteUrl\n      isMarketplace\n      definitiveUrl\n      currencyID\n      currencyCode\n    }\n  }\n  productSwitcherTasks {\n    taskID\n    state\n    taskType\n    lastError\n    elapsedTime\n    modifiedOn\n    extraData {\n      taskID\n      masterSalesChannelID\n      secondarySalesChannelID\n      delayMinutes\n      paymentMethodSetupTaskID\n      sourceSalesChannelID\n      destinationSalesChannelID\n      isSourceSalesChannelDisabled\n    }\n    id\n  }\n  isSellerMigrating\n}\n"
  }
};
})();

(node as any).hash = "2755ccf05ab30552c9c1bd16435008d4";

export default node;
